import config from "../config.json";

const env = process.env.REACT_APP_ENV;

export const configuration = () => {
  return config[env];
};
